export default __webpack_public_path__ + "static/media/mobile_tc2_Cn.178d5c25.webp";